import React from 'react';
import Input from '../../../components/ui/Input';
import Icon from '../../../components/AppIcon';

const ContactInfoSection = ({ formData, errors, onChange }) => {
  return (
    <div className="bg-card border border-border rounded-lg p-6">
      <div className="flex items-center gap-3 mb-6">
        <div className="w-10 h-10 bg-primary/10 rounded-lg flex items-center justify-center">
          <Icon name="Phone" size={20} className="text-primary" />
        </div>
        <div>
          <h2 className="text-lg font-semibold text-text-primary">Contact Information</h2>
          <p className="text-sm text-text-secondary">Business contact details</p>
        </div>
      </div>
      <div className="grid md:grid-cols-2 gap-4">
        <Input
          label="Business Email"
          type="email"
          name="email"
          value={formData?.email}
          onChange={onChange}
          placeholder="contact@company.com"
          error={errors?.email}
          description="Primary contact email"
        />

        <Input
          label="Phone Number"
          type="tel"
          name="phone"
          value={formData?.phone}
          onChange={onChange}
          placeholder="(555) 123-4567"
          error={errors?.phone}
          description="Business phone number"
        />

        <Input
          label="Website URL"
          type="url"
          name="website"
          value={formData?.website}
          onChange={onChange}
          placeholder="https://www.company.com"
          error={errors?.website}
          description="Company website"
        />

        <Input
          label="Business Address"
          type="text"
          name="address"
          value={formData?.address}
          onChange={onChange}
          placeholder="123 Main St, City, State 12345"
          error={errors?.address}
          description="Physical location"
        />
      </div>
    </div>
  );
};

export default ContactInfoSection;